import workData from '../content/work.json';
import type { ServiceSlug } from './services';

export type WorkKind = 'concept' | 'client';
export type WorkStatus = 'published' | 'coming-soon';

export interface WorkItem {
  slug: string;
  title: string;
  industry: string;
  kind: WorkKind;
  serviceTypes: ServiceSlug[];
  description: string;
  image: string;
  tags: string[];
  status: WorkStatus;
  externalPreviewUrl: string | null;
  directHref?: string;
  featured: boolean;
  accent: string;
}

export const workItems = workData as WorkItem[];

const homeSelectedWorkSlugs = [
  'casa-noura',
  'studio-orun',
  'axiom-industrial',
  'veyra-industrial',
  'hush-house',
  'brass-and-blade',
  'forge-auto',
  'honey-and-hearth',
  'mirrorline',
] as const;

const relatedWorkSlugsByService: Record<ServiceSlug, readonly string[]> = {
  'business-websites': ['casa-noura', 'hush-house'],
  'corporate-websites': ['studio-orun'],
  'b2b-catalogues-rfq': ['axiom-industrial', 'veyra-industrial'],
  'website-redesign': ['brass-and-blade', 'forge-auto', 'honey-and-hearth', 'mirrorline'],
  'landing-pages': ['brass-and-blade', 'forge-auto', 'honey-and-hearth', 'mirrorline'],
};

export function getPublishedWork() {
  return workItems.filter((item) => item.status === 'published');
}

export function getWorkBySlug(slug: string) {
  return workItems.find((item) => item.slug === slug && item.status === 'published');
}

export function getWorkForService(serviceSlug: ServiceSlug) {
  return getPublishedWork().filter((item) => item.serviceTypes.includes(serviceSlug));
}

function resolvePublishedWork(slugs: readonly string[], context: string): WorkItem[] {
  return slugs.map((slug) => {
    const item = getWorkBySlug(slug);
    if (!item) throw new Error(`${context} Work item is missing or unpublished: ${slug}`);
    return item;
  });
}

export function getHomeSelectedWork(): WorkItem[] {
  return resolvePublishedWork(homeSelectedWorkSlugs, 'Homepage selected');
}

export function getRelatedWorkForService(serviceSlug: ServiceSlug): WorkItem[] {
  return resolvePublishedWork(relatedWorkSlugsByService[serviceSlug], `Related ${serviceSlug}`);
}
